import { FC } from 'react';
import { mergeClasses } from 'shared/utils/mergeClasses.ts';
import { LoadingSpinner, LoadingSpinnerProps } from './LoadingSpinner.tsx';

export const FullPageLoadingSpinner: FC<LoadingSpinnerProps> = ({ size = 48, className = '' }) => {
  return (
    <div className={mergeClasses('flex h-full w-full items-center justify-center', className)}>
      <LoadingSpinner size={size} />
    </div>
  );
};
